import React, { useState, useContext } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty } from 'lodash';
import { getTranslationByKey } from '../../helpers/translation-helper';
import { DWTCContext } from '../../utils/context';
import {
  BrandPortfolioMobileWrapper,
  BrandPortfolioMobileHeader,
  BrandPortfolioMobileBodyWrapper,
  BrandPortfolioMobileTabs,
  BrandPortfolioMobileTab,
  BrandPortfolioMobileCardContent,
  BrandPortfolioMobileCardButton,
  BrandProtfolioModal,
  BrandProtfolioModalLogo,
  BrandProtfolioModalCloseButton,
  BrandPortfolioModalContent,
  BrandProtfolioModalWrapper,
  PrevButton,
  NextButton,
  LoadMoreButton,
} from '../styles/BrandPortfolio.styled';
import Sprites from '../Sprites';

export default function BrandPortfolioMobile({ data, dir, id }) {
  const { translations } = useContext(DWTCContext);
  const types = data.portfolioTabsList
    ? ['All Brands', ...new Set(data.portfolioTabsList.map(({ content }) => content.brandType))]
    : [];
  const [currIndex, setCurrIndex] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(6);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBrandIndex, setSelectedBrandIndex] = useState(0);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBrandIndex(0);
  };

  const handleClick = (item, index) => {
    setSelectedBrandIndex(index);
    setIsModalOpen(true);
  };

  const handleNext = () => {
    setSelectedBrandIndex((prevIndex) => (prevIndex + 1) % data.portfolioTabsList.length);
  };

  const handlePrev = () => {
    setSelectedBrandIndex((prevIndex) =>
      prevIndex === 0 ? data.portfolioTabsList.length - 1 : prevIndex - 1,
    );
  }
  React.useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  }, [isModalOpen]);

  const handleLoadMore = () => {
    setItemsToShow(itemsToShow + 6);
  };

  const selectedBrand = data.portfolioTabsList[selectedBrandIndex];
  const langDir = dir === 'ar' ? 'rtl' : 'ltr';
  const filteredItems = currIndex === 0
    ? data.portfolioTabsList
    : data.portfolioTabsList.filter(({ content }) => content.brandType === types[currIndex]);

  return (
    <>
      <BrandPortfolioMobileWrapper dir={langDir} id={id} className="smoothed">
        <BrandPortfolioMobileHeader>
          <h2>{data.portfolioTabsTitle}</h2>
        </BrandPortfolioMobileHeader>
        <BrandPortfolioMobileBodyWrapper>
          <BrandPortfolioMobileTabs>
            {isEmpty(types) || types.map((content, index) => (
              <BrandPortfolioMobileTab
                key={index}
                dir={dir}
                onClick={() => setCurrIndex(index)}
                active={index === currIndex}
                className={`${index === currIndex ? 'active-tab' : ''} mobile-tab`}
              >
                {content}
              </BrandPortfolioMobileTab>
            ))}
          </BrandPortfolioMobileTabs>
          <BrandPortfolioMobileCardContent>
            {isEmpty(filteredItems) ||
              filteredItems.slice(0, itemsToShow).map((item, index) => (
                <BrandPortfolioMobileCardButton
                  type="button"
                  key={index}
                  onClick={() => handleClick(item, index)}
                >
                  {isEmpty(item.content.brandImage) || (
                    <LazyLoadImage
                      src={item.content.brandImage.url}
                      effect="blur"
                      alt={item.content.brandTitle}
                      placeholderSrc={
                        item.content.brandImage
                          ? `${item.content.brandImage.url}?width=50&quality=50`
                          : null
                      }
                    />
                  )}
                </BrandPortfolioMobileCardButton>
              ))}
          </BrandPortfolioMobileCardContent>
          {filteredItems.length > itemsToShow && (
            <LoadMoreButton>
              <button type="button" onClick={handleLoadMore}>
                {getTranslationByKey(translations, 'Load More')}
              </button>
            </LoadMoreButton>
          )}
        </BrandPortfolioMobileBodyWrapper>
      </BrandPortfolioMobileWrapper>
      {isModalOpen && selectedBrand !== undefined && (
        <BrandProtfolioModalWrapper>
          <BrandProtfolioModal>
            <BrandProtfolioModalCloseButton onClick={handleCloseModal} dir={dir} />
            <BrandProtfolioModalLogo>
              {isEmpty(data.portfolioTabsList[selectedBrandIndex].content.brandImage) || (
                <LazyLoadImage
                  src={data.portfolioTabsList[selectedBrandIndex].content.brandImage.url}
                  effect="blur"
                  alt={data.portfolioTabsList[selectedBrandIndex].content.brandTitle}
                  placeholderSrc={
                    data.portfolioTabsList[selectedBrandIndex].content.brandImage
                      ? `${data.portfolioTabsList[selectedBrandIndex].content.brandImage.url}?width=50&quality=50`
                      : null
                  }
                />
              )}
            </BrandProtfolioModalLogo>
            <BrandPortfolioModalContent dir={dir}>
              <h2>{data.portfolioTabsList[selectedBrandIndex].content.brandTitle}</h2>
              <p>{data.portfolioTabsList[selectedBrandIndex].content.brandDescription}</p>
            </BrandPortfolioModalContent>
            <PrevButton type="button" onClick={handlePrev}>
              <Sprites name="arrowprev" />
            </PrevButton>
            <NextButton type="button" onClick={handleNext}>
              <Sprites name="arrownext" />
            </NextButton>
          </BrandProtfolioModal>
        </BrandProtfolioModalWrapper>
      )}
    </>
  );
}
